define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var reportingAdminRoles = ['Reporting Administrator'];

	csiAccess.addViewRoles({
		"_CS_Site":{
			"JasperReportTemplates":{
				"UpdateTemplates":access(full(reportingAdminRoles))
			},
			"ReportJobs":{
				"NewReportingJob":access(full(reportingAdminRoles))
			}
		},
		"_CS_Data":{
			"JasperReports":{
				"NewJasperReport":access(full(reportingAdminRoles))
			}
		}
	});
});